import {
  Box,
  Button,
  Container,
  Grid,
  GridItem,
  Image,
  List,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import CheckIcon from "common/assets/img/checkIconCircle.png";
import { landingPageConstants } from "common/landingPageConstants";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";
import TextureBg from "common/assets/img/pricingTextureBg.png";

const PlanList = [
  {
    title: "Standard",
    price: "₹ --",
    subtitle: "Simple CRM for small teams",
    bodyTitle: "This Plan Includes:",
    features: [
      "Unlimited contacts",
      "Bulk emailing",
      "AI Integration",
      "View & share up to 3 years",
      "Collaboration & permissions",
    ],
    buttonText: "Start Free Trial",
    isFreeTrial: false,
  },
  {
    title: "Pro",
    price: "₹ --",
    subtitle: "Advanced CRM for medium teams",
    bodyTitle: "Everything in Standard, plus:",
    features: [
      "Email sequences",
      "Send emails from multiple domains",
      "Connect multiple email accounts",
      "Fully adjustable sharing permissions",
      "Migration services",
    ],
    buttonText: "Get Started",
    isFreeTrial: true,
  },
  {
    title: "Beyond limits",
    price: "Custom Plan",
    subtitle: "Tailored CRM for large teams",
    bodyTitle: "Everything in Standard & Pro, plus:",
    features: [
      "White glove onboarding",
      "Custom billing",
      "Dedicated slack channel",
      "Dedicated point of contact",
      "Unlimited reporting",
    ],
    buttonText: "Get Started",
    isFreeTrial: false,
  },
];

const Pricing = () => {
  return (
    <>
    <Box className="pricingSectionMain">
      <Image src={TextureBg} height={"auto"} width={"100%"} className="pricingTextureBg" alt=""/>
      <Container maxW="container.xl">
        <Box className="pricingSection" id="pricing">
          <Box className="pricingMainBox">
            <Box className="sectionTitlebox">
              <Text className="iconSubtitle">
                {" "}
                <Image
                  src={SubtitleIcon}
                  height={"16px"}
                  width={"16px"}
                  alt=""
                />{" "}
                Pricing plan
              </Text>

              <Text className="sectionTitle">
                {landingPageConstants.pricingTitle}
              </Text>
              <Text className="sectionDesc">
                {landingPageConstants.pricingDesc}
              </Text>
            </Box>
            <Tabs variant="unstyled">
              <Box className="tabListCustomBox">
                <TabList className="tabListCustom">
                  <Tab
                    className="tabItem"
                    _selected={{ color: "black", bg: "white" }}
                  >
                    {landingPageConstants.monthly}
                  </Tab>
                  <Tab
                    className="tabItem"
                    _selected={{ color: "black", bg: "white" }}
                  >
                    {landingPageConstants.annually}
                  </Tab>
                </TabList>
              </Box>
              <Box className="pricingComeSoon">
                <TabPanels>
                <TabPanel paddingLeft={"0px"} paddingRight={"0px"}>
                  <Box className="pricingboxes">
                    <Grid
                      templateColumns={{
                        base: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                      }}
                      gap={"20px"}
                    >
                      {PlanList.map((plan, index) => (
                        <GridItem colSpan={1} key={index}>
                          <Box
                            className={`priceBox ${
                              plan.isFreeTrial ? "active" : ""
                            }`}
                          >
                            <Box>
                              <Box className="pricingHeader">
                                <Text className="pricingLabel">
                                  {plan.title}
                                </Text>
                                <Text className="pricingType">
                                  {plan.subtitle}
                                </Text>
                                <Text className="pricingAmount">
                                  <span className="amount">{plan.price}</span>{" "}
                                  <span>/month</span>
                                </Text>
                              </Box>
                              <Box className="pricingBody">
                                <Text className="pricingBodyTitle">
                                  {plan.bodyTitle}
                                </Text>
                                <ul className="planList">
                                  {plan.features.map((feature, i) => (
                                    <li key={i}>
                                      <Image
                                        src={CheckIcon}
                                        height="24px"
                                        width="24px"
                                        alt=""
                                      />
                                      <span>{feature}</span>
                                    </li>
                                  ))}
                                </ul>
                              </Box>
                            </Box>
                            <Box className="pricingFooter" mt={"20px"}>
                              <Button
                                colorScheme="brand"
                                className={`customButton landingButtons ${
                                  plan.isFreeTrial ? "" : "outlined"
                                }`}
                                height={"52px"}
                              >
                                {plan.buttonText}
                              </Button>
                            </Box>
                          </Box>
                        </GridItem>
                      ))}
                    </Grid>
                  </Box>
                </TabPanel>
                <TabPanel paddingLeft={"0px"} paddingRight={"0px"}>
                  <Box className="pricingboxes">
                    <Grid
                      templateColumns={{
                        base: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                      }}
                      gap={"20px"}
                    >
                      {PlanList.map((plan, index) => (
                        <GridItem colSpan={1} key={index}>
                          <Box
                            className={`priceBox ${
                              plan.isFreeTrial ? "active" : ""
                            }`}
                          >
                            <Box>
                              <Box className="pricingHeader">
                                <Text className="pricingLabel">
                                  {plan.title}
                                </Text>
                                <Text className="pricingType">
                                  {plan.subtitle}
                                </Text>
                                <Text className="pricingAmount">
                                  <span className="amount">{plan.price}</span>{" "}
                                  <span>/month</span>
                                </Text>
                              </Box>
                              <Box className="pricingBody">
                                <Text className="pricingBodyTitle">
                                  {plan.bodyTitle}
                                </Text>
                                <ul className="planList">
                                  {plan.features.map((feature, i) => (
                                    <li key={i}>
                                      <Image
                                        src={CheckIcon}
                                        height="24px"
                                        width="24px"
                                        alt=""
                                      />
                                      <span>{feature}</span>
                                    </li>
                                  ))}
                                </ul>
                              </Box>
                            </Box>
                            <Box className="pricingFooter" mt={"20px"}>
                              <Button
                                colorScheme="brand"
                                className={`customButton ${
                                  plan.isFreeTrial ? "" : "outlined"
                                }`}
                                height={"52px"}
                              >
                                {plan.buttonText}
                              </Button>
                            </Box>
                          </Box>
                        </GridItem>
                      ))}
                    </Grid>
                  </Box>
                </TabPanel>
              </TabPanels>
              <Box className="comingSoonBox">
                <Text>Coming Soon</Text>
              </Box>
              </Box>
            </Tabs>
          </Box>
        </Box>
      </Container>
      </Box>
    </>
  );
};
export default Pricing;
